module.exports = __webpack_public_path__ + "img/topup_desktop.327cf9e5.svg";